import React from 'react'
import makeStyles from '@mui/styles/makeStyles'
import ListItem from '@mui/material/ListItem'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import ListItemIcon from '@mui/material/ListItemIcon'
import MailOutlineIcon from '@mui/icons-material/MailOutline'
import styles from './styles/mailListItemStyle'

const useStyles = makeStyles(styles)
export default function MailList(props: any) {
    const classes = useStyles()
    const { id, mail, callback } = props

    const handleClick = () => {
        if (callback) {
            callback(id, mail)
        }
    }

    return (
        <ListItem className={classes.mailElement}>
            <ListItemIcon className={classes.icon}>
                <MailOutlineIcon />
            </ListItemIcon>
            <ListItemText primary={mail} />
            <ListItemSecondaryAction>
                <IconButton edge="end" aria-label="delete" onClick={() => handleClick()} size="large">
                    <DeleteIcon className={classes.blueIcon} />
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    )
}
